export const loadLocaleData = async (locale: string) => {
  switch (locale) {
    case 'en':
      return await import('../compiled-lang/en.json')
    default:
      return await import('../compiled-lang/ru.json')
  }
}
